import React from "react";

export const TokenFile: React.FC = () => {
  return (
    <div>
      {/* Title */}
      <h1 className="text-2xl font-bold text-gray-900">Generate Access Token</h1>

      <p className="text-gray-500 text-sm mt-1">
        Follow the steps below to generate your API access token. This token is required for all authenticated API requests.
      </p>

      {/* Steps */}
      <div className="mt-6 space-y-4">

        {/* Step 1 */}
        <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
          <p className="text-sm font-semibold text-gray-800 mb-1">Step 1 — Go to Developer Section</p>
          <p className="text-xs text-gray-600">
            Navigate to the Developer section from your dashboard.
          </p>
        </div>

        {/* Step 2 */}
        <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
          <p className="text-sm font-semibold text-gray-800 mb-1">Step 2 — Register Company</p>
          <p className="text-xs text-gray-600">
            Click on <strong>Register Company</strong> and fill in the required details:
          </p>
          <ul className="text-xs text-gray-600 mt-2 list-disc pl-5 space-y-1">
            <li>Company Name</li>
            <li>Website URL</li>
          </ul>
        </div>

        {/* Step 3 */}
        <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-xl">
          <p className="text-sm font-semibold text-yellow-800 mb-1">Step 3 — Approval Time</p>
          <p className="text-xs text-yellow-700">
            Your company registration will be reviewed and approved within <strong>~12 hours</strong>.
          </p>
        </div>

        {/* Step 4 */}
        <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
          <p className="text-sm font-semibold text-gray-800 mb-1">Step 4 — View Company Details</p>
          <p className="text-xs text-gray-600">
            Once approved, go to the <strong>Company List</strong> and click on <strong>View Details</strong>.
          </p>
        </div>

        {/* Step 5 */}
        <div className="p-4 bg-green-50 border border-green-200 rounded-xl">
          <p className="text-sm font-semibold text-green-800 mb-1">Step 5 — Generate Token</p>
          <p className="text-xs text-green-700">
            Click on <strong>Generate Token</strong> to create your API token.
          </p>
        </div>

        {/* Step 6 */}
        <div className="p-4 bg-blue-50 border border-blue-200 rounded-xl">
          <p className="text-sm font-semibold text-blue-800 mb-1">Step 6 — Use Token</p>
          <p className="text-xs text-blue-700">
            Use this token in your API requests as a Bearer token:
          </p>

          <div className="mt-2 bg-white border border-blue-200 rounded-lg p-2 text-xs font-mono text-gray-800">
            Authorization: Bearer YOUR_ACCESS_TOKEN
          </div>
        </div>
      </div>

      {/* Note */}
      <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-xl text-sm text-amber-800">
        <span className="font-semibold">📋 Note:</span> Keep your token secure. Do not expose it in frontend code or public repositories.
      </div>
    </div>
  );
};